import { store } from "Store/store.index";
import { fileController } from 'Components/viewer/Controllers';
import { eSignChinaApi } from '@/api';

export const apiMap = {
    testAPI: (data) => {
        console.log('testAPI', data);
        return Promise.resolve('receive data from online');
    },
    ESignCNFetchUserInfo: () => {
        const tenantId = store?.userStore?.roleInfo?.enterpriseId;
        return eSignChinaApi.getNewSubscription({ tenantId }).then(res => {
            const enterpriseName = res?.orgExternal?.tenantName || res?.orgInternal?.tenantName;
            return {
                Token: store.userStore.token,
                EnterpriseId: tenantId,
                EnterpriseName: enterpriseName,
                pluginVersion: ''
            }
        })
    }, // showESignCNIframeDialog
    ESignCNShowDialog: ({ id, type, title, msg, webUrl, extData, stateHook }) => {
        stateHook({ dialogOpts: { id, type, title, msg, webUrl, extData }, iframeDialogVisible: true })
        return Promise.resolve()
    },
    ESignCNFetchAuditTrailInfo: ({ docHash }) => {
        return store.esignCnStore.getAuditTrailData(docHash)
    },
    ESignCNOpenFileUrl: ({ fileUrl, fileName }) => {
        fileController.doOpenFileByUrl(decodeURIComponent(fileUrl), fileName, (e) => {console.error(e)});
        return Promise.resolve();
    },
    ESignCNShowShareOnlineDocDialog: (params) => {
        store.viewer.pdfui.customs.showEsignCnShareOnlineDocDialog(params);
        return Promise.resolve();
    }
}